export default {"src":"/_next/static/media/footer-app-store-button.ee388572.svg","height":56,"width":189,"blurWidth":0,"blurHeight":0};